import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'py-1 md:py-4',
		inner: 'md:max-w-[62%] md:mx-auto px-2 md:px-4',
		quoteLogoWrapper: 'inline-flex py-1 px-[1.3rem] lg:py-[1.2rem] lg:px-[1.6rem] bg-black rounded-l',
		quoteLogo: 'w-[1.5rem] lg:w-2',
		quoteText: 'col-span-4 lg:col-start-2 lg:col-end-7 mt-2',
		authorWrapper: 'border-t-[1.5px] border-t-black flex flex-col col-span-4 lg:col-start-2 lg:col-end-7 w-full mt-6 pt-2',
	},
})

export type QuoteVariants = VariantProps<typeof styles>
